import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatomoReportsComponent} from './matomo-reports.component';
import {SupplierReportModule} from './supplier-report/supplier-report.module';
import {RouterModule, Routes} from '@angular/router';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {UsersReportModule} from './users-report/users-report.module';
import {MatTableModule} from '@angular/material/table';
import {MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';


export const routes: Routes = [
    {path: '', component: MatomoReportsComponent, pathMatch: 'full'},
];

@NgModule({
    declarations: [
        MatomoReportsComponent
    ],
    imports: [
        CommonModule,
        SupplierReportModule,
        RouterModule.forChild(routes),
        MatAutocompleteModule,
        MatTableModule,
        UsersReportModule,
        MatNativeDateModule,
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'de-DE' }
    ]
})
export class MatomoReportsModule {
}
